var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Time"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.3833 5.99995C10.3833 3.18993 8.10477 0.911377 5.29475 0.911377C2.48473 0.911377 0.206177 3.18993 0.206177 5.99995C0.206177 8.80998 2.48473 11.0885 5.29475 11.0885C6.70259 11.0885 7.96908 10.5175 8.89068 9.59588L8.08781 8.79301C7.37541 9.51107 6.38597 9.95773 5.29475 9.95773C3.10666 9.95773 1.33697 8.18804 1.33697 5.99995C1.33697 3.81186 3.10666 2.04217 5.29475 2.04217C7.48284 2.04217 9.25253 3.81186 9.25253 5.99995H7.55634L9.84054 8.2785L9.88012 8.19935L12.0795 5.99995H10.3833Z",
    fill: "#A6AFCE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.14299 6.56533V3.73834H4.99109V6.14128L6.96998 7.31731L6.56289 8.00144L4.14299 6.56533Z",
    fill: "#A6AFCE"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/time.2836c9959be7a30b2ae9e7434f622def.svg";
export { ForwardRef as ReactComponent };